import React from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText, Divider } from '@mui/material';

const SectorulPatrimoniu: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Sectorul Patrimoniu și Construcții Bisericești
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Departamente și Comisii
          </Typography>
          <List>
            <ListItem>
              <ListItemText 
                primary="Patrimoniu și Construcții Bisericești" 
                secondary="Responsabil pentru patrimoniul bisericesc"
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText 
                primary="Comisia de Construcții și Monumente Bisericești" 
                secondary="Responsabil pentru construcțiile și monumentele bisericești"
              />
            </ListItem>
          </List>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SectorulPatrimoniu;
